<template>
  <div class="dapp-info row">

    <!-- main column -->
    <div class="dapp-info-main col-12 col-md-12 col-lg-8">

      <!-- basic -->
      <div class="dapp-info-card">
        <img v-if="dapp.picture" class="w-100" :src="dapp.picture">
        <h3>{{ dapp.name }}</h3>
        <div class="dapp-description">{{ dapp.description }}</div>
      </div>

      <!-- statistics -->
      <DAppStatistics :dapp="dapp" class="dapp-info-card">
        <h3>{{ $t('statistics') }}</h3>
      </DAppStatistics>

      <!-- contracts -->
      <div v-if="dapp.contracts" class="dapp-info-card">
        <h3>{{ $t('column.contracts') }}</h3>
        <div class="dapp-contracts">
          <a v-for="address in dapp.contracts" :key="address"
             :href="'https://etherscan.io/address/' + address" target="_blank">
            {{ address }}
          </a>
        </div>
      </div>

    </div>
    <!-- // basic -->

    <!-- side -->
    <div class="dapp-info-sidebar col-12 col-md-12 col-lg-4">

      <!-- category -->
      <div class="dapp-info-card horizontal d-flex">

        <DAppCategoryLabel :category="dapp.category"></DAppCategoryLabel>

        <a v-if="dapp.website" :href="dapp.website" target="_blank" class="ml-2 ml-md-4">{{ $t('column.website') }}</a>

        <a v-if="dapp.url" :href="dapp.url" target="_blank" class="ml-2 ml-md-4">{{ $t('column.url') }}</a>

      </div>

      <!-- related -->
      <div class="dapp-info-card">
        <h3>{{ $t('relatedDapps') }}</h3>
        <div>
          <DAppCell v-for="d in relatedDapps" :dapp="d" :key="d.id"></DAppCell>
        </div>
      </div>

    </div><!-- // side -->


  </div>
</template>

<script>
  import DAppCell from '../widgets/DAppCell'
  import DAppStatistics from '../widgets/DAppStatistics'
  import DAppCategoryLabel from '../widgets/DAppCategoryLabel'

  const api = require('./../api')

  export default {
    name: 'dapp-detail',
    components: {DAppCategoryLabel, DAppStatistics, DAppCell},
    data () {
      return {
        dapp: {},
        relatedDapps: []
      }
    },
    mounted () {
      this.fetch()
    },
    watch: {
      $route () {
        this.fetch()
      }
    },
    methods: {
      fetch () {
        api.getDApp(this.$route.params.dapp).then(data => {
          console.log(`dapp`)
          console.log(data)
          this.dapp = data
          api.getDApps({
            category: data.category.key,
            limit: 5
          }).then(data => {
            this.relatedDapps = data.list
          })
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../utils";

  .dapp-info-card {
    background: white;
    border: none;
    margin-bottom: 20px;
    text-overflow: ellipsis;
    padding: 20px;

    @include respond-desktop {
      padding: 40px;
    }

    h3 {
      padding: 0;
    }

    &:not(.horizontal) > *:not(:last-child) {
      margin-bottom: 15px;
      @include respond-desktop {
        margin-bottom: 30px;
      }
    }
  }

  .dapp-description {
    white-space: pre-line;
  }

  .dapp-contracts {
    @include flex-vertical;
    > * {
      overflow-x: hidden;
      text-overflow: ellipsis;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/dapp.vue